import { defineTransform } from "../transform";

defineTransform("delete_object", "create_object", (op1, op2, side) => op1);
defineTransform("delete_object", "delete_object", (op1, op2, side) => {
  // Both are attempting to delete the same object.
  if (op2.p[0] === op1.p[0] && op2.p[1] === op1.p[1]) {
    // op2 already did it, no need for op1.
    return;
  }

  return op1;
});

// If we are deleting the same object that was updated, the delete wins.
defineTransform("delete_object", "update_property", (op1, op2, side) => op1);

defineTransform("delete_object", "stack_create", (op1, op2, side) => op1);
defineTransform("delete_object", "stack_delete", (op1, op2, side) => op1);
